import React,{useRef,useState,useEffect} from 'react';
import {DataTable,QuotationInfoCard} from '../../Components'
import { useNavigate } from 'react-router-dom';
import { Controller, set, useForm } from "react-hook-form";

import {NumberFormat,MobileFormat,DateThaiFormat,DateFormat,DateThai,GetRole} from '../../Utils/Function';
import moment from 'moment';
import ThaiDatePicker from '../../Components/ThaiDatePicker';
import { createRoot } from 'react-dom/client';

import Swal from 'sweetalert2';
import API from '../../API';
import '../../Assets/CSS/TALFC.css';

const PageSaleList =()=> {
    const RedirectTo = useNavigate()
    const { register, getValues, setValue } = useForm();
    const ref = useRef();
    const [_Date,setDate] = useState(new Date());
    const [_StoreList,setStoreList] = useState([]);
    useEffect(() => {
        (async () => {
            setValue("Date",new Date());
            _LoadStoreList();
        })();

        return ()=>{ }
    }, []);
    const _LoadStoreList= async()=>{
        setStoreList([]);
        API({method : "get",url:"/Staff/Store/List"}).then(res=>{
                if (res.status !== 200) {
                    return;
                }

                if (!res.data.Status) {
                    return;
                }
                setStoreList(res.data.Data);
        }).catch(res => {
                return;
        });
    }
   
    const _configs = {
        "order": [[0, "desc"]],
        pageLength: 25,
        orderMulti: true
    }
    
    const _ajax  = {
        'url': '/Report/Sale/List',
        'method': 'POST',
        'caches': false,
        'global': false,
        'data': function (d) {
            d.StoreID = getValues('StoreID');
            const _D = moment(getValues('Date'));
            d.Date = _D.format("YYYY/MM/DD");
        }
    };

    const _Buttons = (d,r) => (
        <div className='btn-group btn-group-sm'>
        </div>
    )
    const _column = [
       {data: "TransactionDate", name: "Created", autoWidth: true,render(data){
            return DateThaiFormat(data,true);
        }},
        { data: "StoreCode", name: "StoreCode", autoWidth: true },
        { data: "StoreName", name: "StoreName", autoWidth: true },
        { data: "MemberCode", name: "MemberCode", autoWidth: true },
        { data: "MemberName", name: "Name", autoWidth: true },
        { data: "Amount", name: "Amount", autoWidth: true,render(data){
            return NumberFormat(data);
        } },
        { data: "TransactionStatusName", name: "TransactionStatus", autoWidth: true },
        { data: "ReasonName", name: "Reason", autoWidth: true },
        {
            data: "TransactionID", name: "TransactionID", autoWidth: true,
            render: (data) => { return ''; },
            createdCell: (td, cellData,rowData) => createRoot(td).render(_Buttons(cellData,rowData))
        }
    ]
    const _ColumnDefs = [
    ]
    
    const _UpdateTable =()=>{
        ref.current?.load();
    }

    return (
        <>
        <React.Fragment>
            <div className='container-fluid'>
                <div className='row mt-4'>
                    <div className='col-lg-12'>
                    <div className='card'>
                            <div className='card-header'>
                                <h3 className='card-title'>รายการยอดขาย</h3>
                            </div>
                            <div className='card-body' style={{'minHeight':'300px'}}>
                                <div className="row mt-2 mb-2 justify-content-end">
                                    <div className='col-12 col-lg-2'>
                                        <ThaiDatePicker className='form-control text-center' selected={_Date} onChange={(date) => { setDate(date);setValue('Date',date); setTimeout(()=>{ref.current.load();},200); }} selectsStart startDate={_Date} maxDate={new Date()} />
                                    </div>
                                    <div className='col-12 col-lg-3 text-end'>
                                        <div className='input-group float-end'>
                                            <select className='form-control text-center' {...register("StoreID", { required: false })} defaultValue={0} onChange={(e)=>{setValue("StoreID",e.target.value); setTimeout(()=>{ref.current.load();},200);}} >
                                                <option value={''} selected>ทั้งหมด</option>
                                                {_StoreList.map((v,i)=>(
                                                    <option key={i} value={v.StoreId}>{v.StoreCode} | {v.StoreName}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-lg-12 table-responsive">
                                        <table id="TransactionTableView" className='table w-100' role='grid'>
                                            <thead>
                                                <tr>
                                                <th className="text-center textcenter">วันที่ / เวลา</th>
                                                <th className="text-center textcenter no-sort">รหัสร้านค้า</th>
                                                <th className="text-center textcenter no-sort">ชื่อร้านค้า</th>
                                                <th className="text-center textcenter no-sort">รหัสประจำตัว</th>
                                                <th className="text-center textcenter no-sort">ชื่อ-นามสกุล</th>
                                                <th className="text-center textcenter">ยอดเงิน</th>
                                                <th className="text-center textcenter no-sortr">สถานะ</th>
                                                <th className="text-center textcenter no-sort">หมายเหตุ</th>
                                                <th className="text-center no-sort"></th>
                                                </tr>
                                            </thead>
                                            <DataTable TableID={"TransactionTableView"} Column={_column} Configs={_configs} ref={ref} ajax={_ajax} ColumnDefs={_ColumnDefs} />
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
        </>
    )
}

export default React.memo(PageSaleList)
